import { useEffect } from 'react';
import { LoginPage } from './pages/LoginPage';
import { RecoveryPage } from './pages/RecoveryPage';
import { SearchPage } from './pages/SearchPage';
import { authDisabled } from './config/endpoints';
import { useAppSelector } from './store/hooks';

export function App() {
  const isAuthorized = useAppSelector((state) => state.auth.isAuthorized);
  const isPublicPage = window.location.pathname === '/login' || window.location.pathname === '/recovery';

  useEffect(() => {
    if (!authDisabled && !isPublicPage && !isAuthorized) window.location.replace('/login');
  }, [isAuthorized, isPublicPage]);

  if (window.location.pathname === '/login') return <LoginPage />;
  if (window.location.pathname === '/recovery') return <RecoveryPage />;
  return authDisabled || isAuthorized ? <SearchPage /> : null;
}
